import React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { useSession } from "../hooks/useSession";

interface PrivateRouteProps extends RouteProps {}

export const PrivateRoute: React.FC<PrivateRouteProps> = ({ ...res }) => {
  const { getSessionAuthorization, getUser } = useSession();
  const user = getUser();

  if (user?.role.includes("EVENTOS")) {
    if (!res.path?.includes("events") && !res.path?.includes("account")) {
      return (
        <Redirect to={{ pathname: "/events", state: { from: res.location } }} />
      );
    }
  }

  return getSessionAuthorization(true) ? (
    <Route {...res} />
  ) : (
    <Redirect to={{ pathname: "/", state: { from: res.location } }} />
  );
};
